import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DashboardConfiguration,
  ReportsConfiguration,
  Sort,
  TableConfiguration,
} from 'features/user-preferences/types/user-preferences.types';
import { SmartTable } from '@certemy/ui-components';

export const TablePreferencesActions = createActionGroup({
  source: 'User Preferences [Table]',
  events: {
    'Reset User Table Configuration': props<{ tableKey: string }>(),
    'Set User Table Configuration': props<{ tableKey: string; tableConfiguration: TableConfiguration }>(),

    'Set Table Configuration Filters': props<{ tableKey: string; filters: object }>(),
    'Reset Table Configuration Filters': props<{ tableKey: string }>(),

    'Set Table Order': props<{ tableKey: string; sort: Sort }>(),
    'Reset Table Order': props<{ tableKey: string }>(),
  },
});

export const CustomFieldsPreferencesActions = createActionGroup({
  source: 'User Preferences [Custom Fields]',
  events: {
    'Set Custom Fields State': props<{ customFieldsKey: string; customFieldsState: Record<string, boolean> }>(),
    'Reset Custom Fields State': props<{ customFieldsKey: string }>(),
  },
});

export const DashboardPreferencesActions = createActionGroup({
  source: 'User Preferences [Dashboard]',
  events: {
    'Reset Dashboard Configuration': props<{ dashboardName: string; configuration: DashboardConfiguration }>(),
    'Initialize Dashboard Configuration': props<{
      dashboardName: string;
      configuration: DashboardConfiguration;
    }>(),
    'Update Dashboard Smart Filters': props<{ dashboardName: string; smartFilters: object }>(),
    'Reset Dashboard Smart Filters': props<{ dashboardName: string; smartFilters: object }>(),
  },
});

export const ReportsPreferencesActions = createActionGroup({
  source: 'User Preferences [Reports]',
  events: {
    'Reset Reports Configuration': props<{ reportsName: string; configuration: ReportsConfiguration }>(),
    'Initialize Reports Configuration': props<{
      reportsName: string;
      configuration: ReportsConfiguration;
    }>(),
    'Update Reports Smart Filters': props<{ reportsName: string; smartFilters: object }>(),
    'Reset Reports Smart Filters': props<{ reportsName: string; smartFilters: object }>(),
    'Reset Table Order': props<{ reportsName: string; tableKey: string }>(),
    'Update Table Order': props<{ reportsName: string; tableKey: string; tableOrder: SmartTable.OrderedHeader }>(),
  },
});
